import React, { useState } from "react";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { MdExpandMore, MdPower } from "react-icons/md";
import { userActions } from "../../../../actions";
import { getUser } from "../../../../selector/user";
import user1 from "../../../../assets/images/users/avatar-1.jpg";
import { Link } from "react-router-dom";

const ProfileMenu = ({ user, logout }) => {
  const [listOpen, setListOpen] = useState(false);

  const firstname = (user && user.firstname) || "";
  const lastname = (user && user.lastname) || "";

  return (
    <React.Fragment>
      <Dropdown className="d-inline-block profile-menu">
        <Dropdown.Toggle
          className="btn header-item waves-effect bg-transperant"
          id="page-header-user-dropdown"
        >
          <img className="rounded-circle header-profile-user" src={user1} alt="Header Avatar" />
          <span className="d-none d-xl-inline-block ml-2 mr-1">
            {firstname} {lastname}
          </span>
          <MdExpandMore />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Link to="#" onClick={logout} className="dropdown-item">
            <MdPower className="ic_extra_small mr-2" />
            <span>{"Logout"}</span>
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
  };
};

const mapDispatchToProps = {
  logout: userActions.logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu);
